import { createAction } from "../../utils/redux/createAction";
import { UPDATE_NEWS_DATA } from "./types";
import { INewsState, IAction } from "../../ts/redux";

export function updateNewsData(payload: INewsState): IAction {
    return createAction(UPDATE_NEWS_DATA, payload);
}